import { CardPaymentsStatsigStore } from './store'

export const CardPaymentsStatsig = {
  Store: CardPaymentsStatsigStore,
}
